import { Type, plainToInstance } from 'class-transformer'
import { FolderPath } from '@core/entities/folders/FolderResponse'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import {
  DocumentPreviewMode,
  FileFormat,
  StatusType,
} from '@core/entities/SiteBoxDocument'
import { FILE_FORMATS } from '@core/entities/SiteBoxDocument/fileFormat'
import { ISiteBoxDocumentVersionBase } from '@core/entities/SiteBoxDocumentVersionBase'

export class SiteBoxDocumentVersionBase<
  ExtendedType extends ISiteBoxDocumentVersionBase = ISiteBoxDocumentVersionBase,
> extends Entity<ExtendedType> {
  id: number
  format: FileFormat
  documentId: number
  documentVersion: number
  documentKey: string
  documentGetUrl: string
  documentDownloadUrl: string
  status: StatusType
  imageGetUrl: string

  @Type(() => User)
  modifiedBy: User

  modifiedOn: string

  @Type(() => User)
  createdBy: User

  createdOn: string
  folder: {
    folderId: number
    pathFromRoot: FolderPath
  }

  public static new(
    payload: ISiteBoxDocumentVersionBase,
  ): SiteBoxDocumentVersionBase {
    const entity = plainToInstance<
      SiteBoxDocumentVersionBase,
      ISiteBoxDocumentVersionBase
    >(SiteBoxDocumentVersionBase, payload)

    return entity
  }

  public getPreviewMode(): DocumentPreviewMode {
    switch (this.format) {
      case 'PDF':
        return 'PDF'
      case 'JPEG':
      case 'PNG':
        return 'IMAGE'
      case 'MP4':
        return 'VIDEO'
      default:
        return 'DOWNLOAD'
    }
  }

  public getMimeType(): string {
    return FILE_FORMATS[this.format]?.mimeType ?? 'application/octet-stream'
  }

  public getExtension(): string {
    const extension = FILE_FORMATS[this.format]?.extension
    return extension ? `.${extension}` : ''
  }
}
